import { useState, useEffect } from 'react';
import { Accordion, Card, AccordionProps, Form, Container, Modal, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';
import CustomSelect from '../../../components/Select';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import ModalBody from 'react-bootstrap/ModalBody';
import GenericList, { GenericListItem } from '../../../components/GenericList';
import Link from '../../../components/Link/Link';
import ModalHeader from '../../../components/ModalHeader';
import { VerticalStepsType } from '../../../types';
import recentPayments from '../../../data/recentPayments/recentPayments.json';

export type RecentPaymentsModalProps = {
    showRecentPaymentsModal: boolean;
    handleCloseRecentPaymentsModal: () => void;
    data: {
        planName: string;
        paymentDate: string;
        currentGrossAmount: number;
        currentMothlyPension: number;
        currentRetroactivePension: number;
        currentDeductions: number;
        currentFederalTaxWitholding: number;
        currentFederalStateWitholding: number;
        YTDGrossAmount: number;
        YTDMothlyPension: number;
        YTDRetroactivePension: number;
        YTDDeductions: number;
        YTDFederalTaxWitholding: number;
        YTDFederalStateWitholding: number;
        
      // Add types for other data fields as needed
    };
    currentStep: number;
    goToStep: () => void;
};
  
const RecentPaymentsModal =  ({
    showRecentPaymentsModal,
    handleCloseRecentPaymentsModal,
    data,
  }: RecentPaymentsModalProps) => {
    const {
        planName,
        paymentDate,
        currentGrossAmount,
        currentMothlyPension,
        currentRetroactivePension,
        currentDeductions,
        currentFederalTaxWitholding,
        currentFederalStateWitholding,
        YTDGrossAmount,
        YTDMothlyPension,
        YTDRetroactivePension,
        YTDDeductions,
        YTDFederalTaxWitholding,
        YTDFederalStateWitholding
    } = data;

    const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
    const [options, setOptions] = useState([]);
    const [selectedPaymentDate, setSelectedPaymentDate] = useState('');

    /*const options = [
        { value: '1', label: '22/11/2022' },
        { value: '2', label: '22/12/2022' },
        { value: '3', label: '22/01/2023' },
    ];*/
    useEffect(() => {
      // Fetch data from the JSON file
      const fetchData = async () => {
        try {
          // Simulate fetching data from the JSON file
          // Replace this with your actual fetch call
          const data = recentPayments.data['persona-retiree-inpay'];
          // Map the data to the format required by the Select component
          const mappedOptions = data.map((item) => ({
            value: item.id.toString(),
            label: item.paymentDate,
          }));
          setOptions(mappedOptions as any);
          // Check if the payment date exists in the JSON data
          const matchingDate = data.find(
            (item) => item.paymentDate === paymentDate
          );
          if (matchingDate) {
            setSelectedPaymentDate(matchingDate.id.toString());
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };

      fetchData();
    }, [selectedPaymentDate]);

    const numberToCurrencyString = (number: number): string => {
        // Format the number as currency
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(number);
      };

    const handleOnDateChange = (e: any) => {
        if (e === '1') {

        } else if (e === '2') {

        } else if (e === '3') {

        }
      };

    const collapsedHandler = () => {
        setIsCollapsed((state) => !state);
    };

  return (
    <Modal
      show={showRecentPaymentsModal}
      onHide={handleCloseRecentPaymentsModal}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Payments Details</h4>
      </ModalHeader>
      <ModalBody>
        <Container className="p-0">
          <Row>
            <Col className={'col-12 col-lg-4'}>
              <div>
                <CustomSelect options={options} value={selectedPaymentDate} onChange={handleOnDateChange} />
              </div>
            </Col>
            <Col
              className={
                'd-flex flex-column-reverse flex-lg-column col-12 col-lg-3 offset-lg-5 mt-7 mt-lg-0'
              }
            >
              <a
                className={'text-decoration-none'}
                href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                target={'_blank'}
                rel="noreferrer"
              >
                <Button
                  leftIcon={light('file-download')}
                  variant="primary-outline"
                  className={'order-1 order-lg-3 w-100 mt-4 mt-lg-0'}
                  size="sm"
                >
                  Download/Print
                </Button>
              </a>
            </Col>
          </Row>

          <Card className="mt-6">
            <Card.Body>
              <Row className="p-0 mb-5">
                <Col className="col-12">
                  <h5 className="text-sub1 fw-normal">Payment Details - {planName}</h5>
                </Col>
              </Row>

              <Row className="p-0 mb-5">
                <Col className="d-flex"></Col>
                <Col className="d-flex flex-column col-4 align-items-end pe-8">
                  <span className="text-sub1 fw-normal">Current</span>
                </Col>
                <Col className="d-flex flex-column col-4 align-items-end pe-10">
                  <span className="text-sub1 fw-normal">Year-To-Date</span>
                </Col>
              </Row>

              <Accordion className={'mt-6'} alwaysOpen={true} flush={true}>
                <Accordion.Item
                  eventKey="0"
                  className={`mb-10 simple-accordion-custom ${
                    !isCollapsed ? 'accordion-shadow' : ''
                  }`}
                >
                  <Accordion.Header
                    className="accordion-header"
                    onClick={collapsedHandler}
                  >
                    <Container className="header-container p-0">
                      <Row className="first-subtitle d-flex align-items-center p-0 text-sub1 fw-light">
                        <Col className="d-flex fw-normal">Gross Amount</Col>
                        <Col className="d-flex flex-column align-items-end pe-9">
                          <span className="fw-normal mt-lg-1">{numberToCurrencyString(currentGrossAmount)}</span>
                        </Col>
                        <Col className="d-flex flex-column align-items-end">
                          <span className="fw-normal mt-lg-1">{numberToCurrencyString(YTDGrossAmount)}</span>
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Header>
                  <Accordion.Body className="py-0 text-sub1 fw-light">
                    <Container className="p-0">
                      <Row className="pb-7">
                        <Col className="">
                          <span className="ms-lg-11">Monthly Pension</span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">{numberToCurrencyString(currentMothlyPension)}</span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">{numberToCurrencyString(YTDMothlyPension)}</span>
                        </Col>
                      </Row>
                      <Row className="pb-7">
                        <Col className="">
                          <span className="ms-lg-11">Retroactive Pension</span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">
                            {numberToCurrencyString(currentRetroactivePension)}
                          </span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">
                            {numberToCurrencyString(YTDRetroactivePension)}
                          </span>
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="1"
                  className={`simple-accordion-custom ${
                    !isCollapsed ? 'accordion-shadow' : ''
                  }`}
                >
                  <Accordion.Header
                    className="accordion-header"
                    onClick={collapsedHandler}
                  >
                    <Container className="header-container p-0">
                      <Row className="first-subtitle d-flex align-items-center p-0 text-sub1 fw-light">
                        <Col className="d-flex fw-normal">Deductions</Col>
                        <Col className="d-flex flex-column align-items-end pe-9">
                          <span className="fw-normal mt-lg-1">({numberToCurrencyString(currentDeductions)})</span>
                        </Col>
                        <Col className="d-flex flex-column align-items-end">
                          <span className="fw-normal mt-lg-1">({numberToCurrencyString(YTDDeductions)})</span>
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Header>
                  <Accordion.Body className="py-0 text-sub1 fw-light">
                    <Container className="p-0">
                      <Row className="pb-7">
                        <Col className="">
                          <span className="ms-lg-11">Federal Tax Witholding</span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">
                            {numberToCurrencyString(currentFederalTaxWitholding)}
                          </span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">
                            {numberToCurrencyString(YTDFederalTaxWitholding)}
                          </span>
                        </Col>
                      </Row>
                      <Row className="pb-7">
                        <Col className="">
                          <span className="ms-lg-11">State Tax Witholding</span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">
                            {numberToCurrencyString(currentFederalStateWitholding)}
                          </span>
                        </Col>
                        <Col className="d-flex justify-content-end">
                          <span className="text-light-grey-normal">
                            {numberToCurrencyString(YTDFederalStateWitholding)}
                          </span>
                        </Col>
                      </Row>
                    </Container>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Row>
                <Col className="second-subtitle d-flex mx-11 ps-8 pe-0 pt-5 pb-9 text-sub1 fw-light border-top">
                  <div className="d-flex col">
                    <span className="fw-normal">Net Amount</span>
                  </div>
                  <div className="ms-auto d-flex col-4 justify-content-end pe-6">
                    <span className="fw-normal">{numberToCurrencyString(currentGrossAmount - currentDeductions)}</span>
                  </div>
                  <div className="ms-auto d-flex col-4 justify-content-end pe-0">
                    <span className="fw-normal">{numberToCurrencyString(YTDGrossAmount - YTDDeductions)}</span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
        <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
          <Button
            className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1"
            variant="primary-outline"
            onMouseDown={handleCloseRecentPaymentsModal}
          >
            Close
          </Button>
        </section>
      </ModalBody>
    </Modal>
  );
}

export default RecentPaymentsModal